require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-luca-tami.json") })
        }
      }, "path---en-interviste-luca-tami");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-luca-tami!./.cache/json/en-interviste-luca-tami.json
// module id = 587
// module chunks = 231608221292675